export const REPORTS_CHAT_COLORS = {
  declined: '#F38B8D',
  waiting_for_response: '#5B8FCE',
  payment_in_progress: '#E1E7ED',
  paid: '#9CD652',
  partially_paid: '#FFB71B',
  payment_failed: '#E5565C',
  disputed: '#F38B8D',
  past_due: '#C47E00'
}
